import React, { ChangeEvent, FC, useState } from 'react';

import { Box, debounce } from '@mui/material';

import { metaTitle } from '../../util/tabTitle';
import KvsKeyValuesTable from './KvsKeyValuesTable';
import { DEBOUNCE_TIME } from '../../configs';
import Breadcrumbs from '../../components/Breadcrumb';
import { useLocation, useParams } from 'react-router-dom';
import {
  ManagementSearch,
  ManagementToolbar,
  ManagementPageHeader,
} from '../../components/ManagementPageLayout';
import { useGetPaginateKvs } from '../../api-http/kvs';

const KvsGroupPage: FC = () => {
  metaTitle('KVS Group');
  const [searchText, setSearchText] = useState('');

  const onSearch = (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setSearchText(e.target.value);
  };

  const paramId = useParams();
  const { id: kvsGroupId } = paramId;

  const { data: kvsGroups } = useGetPaginateKvs({
    search: '',
    limit: 100,
    page: 0,
  });

  const location = useLocation();
  const { state, pathname } = location;
  const fetchedGroupName = kvsGroups?.data.find(
    (group) => group._id === kvsGroupId,
  )?.name;
  const kvsGroupName = state?.groupName || fetchedGroupName || 'Key group';

  const searchParams = state?.search;
  const kvsPageUrl = searchParams ? `/kvs${searchParams}` : '/kvs';

  return (
    <Box sx={{ width: '100%', maxWidth: 1360, mx: 'auto' }}>
      <Breadcrumbs
        items={[
          {
            label: 'KVS',
            to: kvsPageUrl,
          },
          { label: `${kvsGroupName}`, to: pathname },
        ]}
      />
      <ManagementPageHeader
        title={kvsGroupName}
        subtitle="Edit values directly while keeping keys protected."
      />
      <ManagementToolbar>
        <ManagementSearch
          placeholder="Search key values"
          value={searchText}
          onChange={debounce((event) => onSearch(event), DEBOUNCE_TIME)}
        />
        <Box />
      </ManagementToolbar>
      <KvsKeyValuesTable
        searchText={searchText}
        kvsGroupId={kvsGroupId as string}
        kvsGroupName={kvsGroupName}
      />
    </Box>
  );
};

export default KvsGroupPage;
